/* tslint:disable */
/* eslint-disable */
/**
 * WESMASH2 PRENOTAZIONI 2 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface Booking
 */
export interface Booking {
    /**
     * 
     * @type {string}
     * @memberof Booking
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof Booking
     */
    'club_id': string;
    /**
     * 
     * @type {string}
     * @memberof Booking
     */
    'playground_id': string;
}
/**
 * 
 * @export
 * @interface BookingDetailsDto
 */
export interface BookingDetailsDto {
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'creation_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'booking_state'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BookingDetailsDto
     */
    'club_membership'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'club_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'club_name': string;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'club_address': string;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'club_phone_number': string;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'playground_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'playground_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'playground_ground': string;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'playground_exposure': string;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'playground_sport': string;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'playground_size': string;
    /**
     * 
     * @type {number}
     * @memberof BookingDetailsDto
     */
    'start_at'?: number;
    /**
     * 
     * @type {number}
     * @memberof BookingDetailsDto
     */
    'end_at'?: number;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'sport_type': string;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'match_type': string;
    /**
     * 
     * @type {number}
     * @memberof BookingDetailsDto
     */
    'min_level'?: number;
    /**
     * 
     * @type {number}
     * @memberof BookingDetailsDto
     */
    'max_level'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BookingDetailsDto
     */
    'isPublic'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'wesmash_user_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'wesmash_user2_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'wesmash_user3_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'wesmash_user4_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'player_family_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'player_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'player_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'player_phone_number'?: string;
    /**
     * 
     * @type {PlayerDto}
     * @memberof BookingDetailsDto
     */
    'player_1'?: PlayerDto;
    /**
     * 
     * @type {PlayerDto}
     * @memberof BookingDetailsDto
     */
    'player_2'?: PlayerDto;
    /**
     * 
     * @type {PlayerDto}
     * @memberof BookingDetailsDto
     */
    'player_3'?: PlayerDto;
    /**
     * 
     * @type {PlayerDto}
     * @memberof BookingDetailsDto
     */
    'player_4'?: PlayerDto;
    /**
     * 
     * @type {number}
     * @memberof BookingDetailsDto
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof BookingDetailsDto
     */
    'taking'?: number;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'state'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BookingDetailsDto
     */
    'playground_confirmed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'payment_state'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'payment_choice'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'split_payment'?: string;
    /**
     * 
     * @type {Array<MinimalBookingPaymentDto>}
     * @memberof BookingDetailsDto
     */
    'payments'?: Array<MinimalBookingPaymentDto>;
    /**
     * 
     * @type {number}
     * @memberof BookingDetailsDto
     */
    'player_1_taking'?: number;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'player_1_payment_choice'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'player_1_payment_state'?: BookingDetailsDtoPlayer1PaymentStateEnum;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'player_1_booking_category'?: BookingDetailsDtoPlayer1BookingCategoryEnum;
    /**
     * 
     * @type {number}
     * @memberof BookingDetailsDto
     */
    'player_2_taking'?: number;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'player_2_payment_choice'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'player_2_payment_state'?: BookingDetailsDtoPlayer2PaymentStateEnum;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'player_2_booking_category'?: BookingDetailsDtoPlayer2BookingCategoryEnum;
    /**
     * 
     * @type {number}
     * @memberof BookingDetailsDto
     */
    'player_3_taking'?: number;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'player_3_payment_choice'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'player_3_payment_state'?: BookingDetailsDtoPlayer3PaymentStateEnum;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'player_3_booking_category'?: BookingDetailsDtoPlayer3BookingCategoryEnum;
    /**
     * 
     * @type {number}
     * @memberof BookingDetailsDto
     */
    'player_4_taking'?: number;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'player_4_payment_choice'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'player_4_payment_state'?: BookingDetailsDtoPlayer4PaymentStateEnum;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'player_4_booking_category'?: BookingDetailsDtoPlayer4BookingCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof BookingDetailsDto
     */
    'open_door_id'?: string;
}

export const BookingDetailsDtoPlayer1PaymentStateEnum = {
    Unpaid: 'UNPAID',
    PaidCash: 'PAID_CASH',
    PaidCard: 'PAID_CARD',
    PaidBancomat: 'PAID_BANCOMAT',
    PaidBank: 'PAID_BANK'
} as const;

export type BookingDetailsDtoPlayer1PaymentStateEnum = typeof BookingDetailsDtoPlayer1PaymentStateEnum[keyof typeof BookingDetailsDtoPlayer1PaymentStateEnum];
export const BookingDetailsDtoPlayer1BookingCategoryEnum = {
    Institutional: 'INSTITUTIONAL',
    Commercial: 'COMMERCIAL'
} as const;

export type BookingDetailsDtoPlayer1BookingCategoryEnum = typeof BookingDetailsDtoPlayer1BookingCategoryEnum[keyof typeof BookingDetailsDtoPlayer1BookingCategoryEnum];
export const BookingDetailsDtoPlayer2PaymentStateEnum = {
    Unpaid: 'UNPAID',
    PaidCash: 'PAID_CASH',
    PaidCard: 'PAID_CARD',
    PaidBancomat: 'PAID_BANCOMAT',
    PaidBank: 'PAID_BANK'
} as const;

export type BookingDetailsDtoPlayer2PaymentStateEnum = typeof BookingDetailsDtoPlayer2PaymentStateEnum[keyof typeof BookingDetailsDtoPlayer2PaymentStateEnum];
export const BookingDetailsDtoPlayer2BookingCategoryEnum = {
    Institutional: 'INSTITUTIONAL',
    Commercial: 'COMMERCIAL'
} as const;

export type BookingDetailsDtoPlayer2BookingCategoryEnum = typeof BookingDetailsDtoPlayer2BookingCategoryEnum[keyof typeof BookingDetailsDtoPlayer2BookingCategoryEnum];
export const BookingDetailsDtoPlayer3PaymentStateEnum = {
    Unpaid: 'UNPAID',
    PaidCash: 'PAID_CASH',
    PaidCard: 'PAID_CARD',
    PaidBancomat: 'PAID_BANCOMAT',
    PaidBank: 'PAID_BANK'
} as const;

export type BookingDetailsDtoPlayer3PaymentStateEnum = typeof BookingDetailsDtoPlayer3PaymentStateEnum[keyof typeof BookingDetailsDtoPlayer3PaymentStateEnum];
export const BookingDetailsDtoPlayer3BookingCategoryEnum = {
    Institutional: 'INSTITUTIONAL',
    Commercial: 'COMMERCIAL'
} as const;

export type BookingDetailsDtoPlayer3BookingCategoryEnum = typeof BookingDetailsDtoPlayer3BookingCategoryEnum[keyof typeof BookingDetailsDtoPlayer3BookingCategoryEnum];
export const BookingDetailsDtoPlayer4PaymentStateEnum = {
    Unpaid: 'UNPAID',
    PaidCash: 'PAID_CASH',
    PaidCard: 'PAID_CARD',
    PaidBancomat: 'PAID_BANCOMAT',
    PaidBank: 'PAID_BANK'
} as const;

export type BookingDetailsDtoPlayer4PaymentStateEnum = typeof BookingDetailsDtoPlayer4PaymentStateEnum[keyof typeof BookingDetailsDtoPlayer4PaymentStateEnum];
export const BookingDetailsDtoPlayer4BookingCategoryEnum = {
    Institutional: 'INSTITUTIONAL',
    Commercial: 'COMMERCIAL'
} as const;

export type BookingDetailsDtoPlayer4BookingCategoryEnum = typeof BookingDetailsDtoPlayer4BookingCategoryEnum[keyof typeof BookingDetailsDtoPlayer4BookingCategoryEnum];

/**
 * 
 * @export
 * @interface BookingOtherFieldDTO
 */
export interface BookingOtherFieldDTO {
    /**
     * 
     * @type {string}
     * @memberof BookingOtherFieldDTO
     */
    'match_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingOtherFieldDTO
     */
    'split_payment'?: string;
}
/**
 * 
 * @export
 * @interface MinimalBookingPaymentDto
 */
export interface MinimalBookingPaymentDto {
    /**
     * 
     * @type {string}
     * @memberof MinimalBookingPaymentDto
     */
    'id': string;
    /**
     * ID Utente in formato UUID
     * @type {string}
     * @memberof MinimalBookingPaymentDto
     */
    'userId': string;
    /**
     * Quota richiesta in fase di pagamento
     * @type {number}
     * @memberof MinimalBookingPaymentDto
     */
    'quota': number;
    /**
     * Data programmata per l\'avvio delle transazioni
     * @type {string}
     * @memberof MinimalBookingPaymentDto
     */
    'dueDate': string;
    /**
     * Stato attuale del pagamento
     * @type {string}
     * @memberof MinimalBookingPaymentDto
     */
    'status': MinimalBookingPaymentDtoStatusEnum;
    /**
     * Lista di pagamenti SLAVE che contribuiscono al pagamento MASTER
     * @type {Array<SlavePayment>}
     * @memberof MinimalBookingPaymentDto
     */
    'slavePayments': Array<SlavePayment>;
}

export const MinimalBookingPaymentDtoStatusEnum = {
    Scheduled: 'SCHEDULED',
    Cancelled: 'CANCELLED',
    InProgress: 'IN_PROGRESS',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
    Refunded: 'REFUNDED'
} as const;

export type MinimalBookingPaymentDtoStatusEnum = typeof MinimalBookingPaymentDtoStatusEnum[keyof typeof MinimalBookingPaymentDtoStatusEnum];

/**
 * 
 * @export
 * @interface PlayerDto
 */
export interface PlayerDto {
    /**
     * 
     * @type {string}
     * @memberof PlayerDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PlayerDto
     */
    'family_name': string;
    /**
     * 
     * @type {string}
     * @memberof PlayerDto
     */
    'player_category'?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerDto
     */
    'pic'?: string;
}
/**
 * 
 * @export
 * @interface SlavePayment
 */
export interface SlavePayment {
    /**
     * ID Utente in formato UUID
     * @type {string}
     * @memberof SlavePayment
     */
    'userId': string;
    /**
     * Quota richiesta in fase di pagamento come contributo al pagamento totale
     * @type {number}
     * @memberof SlavePayment
     */
    'quota': number;
    /**
     * Stato attuale del pagamento
     * @type {string}
     * @memberof SlavePayment
     */
    'status': SlavePaymentStatusEnum;
}

export const SlavePaymentStatusEnum = {
    Scheduled: 'SCHEDULED',
    Cancelled: 'CANCELLED',
    InProgress: 'IN_PROGRESS',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
    Refunded: 'REFUNDED'
} as const;

export type SlavePaymentStatusEnum = typeof SlavePaymentStatusEnum[keyof typeof SlavePaymentStatusEnum];

/**
 * 
 * @export
 * @interface SubscribeRequest
 */
export interface SubscribeRequest {
    /**
     * 
     * @type {string}
     * @memberof SubscribeRequest
     */
    'wesmash_user_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof SubscribeRequest
     */
    'spot': number;
}
/**
 * 
 * @export
 * @interface UnsubscribeRequest
 */
export interface UnsubscribeRequest {
    /**
     * 
     * @type {string}
     * @memberof UnsubscribeRequest
     */
    'wesmash_user_id'?: string;
}
/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'id': string;
    /**
     * Version of the user schema, v1 for imported users and v2 for users created on the new app
     * @type {string}
     * @memberof User
     */
    'version': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'email': string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'emailVerified': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'socialProvided': boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'nome': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'cognome': string;
    /**
     * 
     * @type {object}
     * @memberof User
     */
    'cell': object;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'cellVerified': boolean;
    /**
     * 
     * @type {object}
     * @memberof User
     */
    'gender': object;
    /**
     * 
     * @type {object}
     * @memberof User
     */
    'dataDiNascita': object;
    /**
     * 
     * @type {object}
     * @memberof User
     */
    'citta': object;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'country': string;
    /**
     * 
     * @type {object}
     * @memberof User
     */
    'situazioneSentimentale': object;
    /**
     * 
     * @type {object}
     * @memberof User
     */
    'statusProfessionale': object;
    /**
     * 
     * @type {object}
     * @memberof User
     */
    'urlFoto': object;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'profilazioneGG': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'marketingGG': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'marketingTerzeParti': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'terminiCondizioni': boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'profile_pic_ref': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'updatedAt': string;
}

/**
 * PingApi - axios parameter creator
 * @export
 */
export const PingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ping: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/ping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PingApi - functional programming interface
 * @export
 */
export const PingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ping(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ping(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PingApi.ping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PingApi - factory interface
 * @export
 */
export const PingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PingApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ping(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.ping(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PingApi - object-oriented interface
 * @export
 * @class PingApi
 * @extends {BaseAPI}
 */
export class PingApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PingApi
     */
    public ping(options?: RawAxiosRequestConfig) {
        return PingApiFp(this.configuration).ping(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PrenotazioniApi - axios parameter creator
 * @export
 */
export const PrenotazioniApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingDetail: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBookingDetail', 'id', id)
            const localVarPath = `/v2/prenotazioni/detail/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Legge elenco prenotazioni
         * @param {boolean} [archived] 
         * @param {boolean} [deleted] 
         * @param {boolean} [future] 
         * @param {GetBookingsGroupTypeEnum} [groupType] 
         * @param {number} [limit] Any integer &gt; 0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookings: async (archived?: boolean, deleted?: boolean, future?: boolean, groupType?: GetBookingsGroupTypeEnum, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/prenotazioni`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (archived !== undefined) {
                localVarQueryParameter['archived'] = archived;
            }

            if (deleted !== undefined) {
                localVarQueryParameter['deleted'] = deleted;
            }

            if (future !== undefined) {
                localVarQueryParameter['future'] = future;
            }

            if (groupType !== undefined) {
                localVarQueryParameter['group_type'] = groupType;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Legge elenco prenotazioni per un determinato club in un dato giorno
         * @param {string} clubId 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendar: async (clubId: string, date: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clubId' is not null or undefined
            assertParamExists('getCalendar', 'clubId', clubId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getCalendar', 'date', date)
            const localVarPath = `/v2/prenotazioni/get-calendar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clubId !== undefined) {
                localVarQueryParameter['club_id'] = clubId;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Legge elenco prossime N prenotazioni per lo user connesso  a partire da ora meno eventualmente X ore. N e X sono parametri di query opsionali che valgono 3 e 0 come default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextBookings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/prenotazioni/next-bookings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get open games by club
         * @param {string} clubId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpenGames: async (clubId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clubId' is not null or undefined
            assertParamExists('getOpenGames', 'clubId', clubId)
            const localVarPath = `/v2/prenotazioni/open-games`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clubId !== undefined) {
                localVarQueryParameter['club_id'] = clubId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSelf: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/prenotazioni/self`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Aggiunta campi nuovi su booking
         * @param {string} bookingId 
         * @param {BookingOtherFieldDTO} bookingOtherFieldDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOtherField: async (bookingId: string, bookingOtherFieldDTO: BookingOtherFieldDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('setOtherField', 'bookingId', bookingId)
            // verify required parameter 'bookingOtherFieldDTO' is not null or undefined
            assertParamExists('setOtherField', 'bookingOtherFieldDTO', bookingOtherFieldDTO)
            const localVarPath = `/v2/prenotazioni/{bookingId}/setotherfield`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bookingOtherFieldDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Assegna un utente a una partita
         * @param {string} id 
         * @param {SubscribeRequest} subscribeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribe: async (id: string, subscribeRequest: SubscribeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('subscribe', 'id', id)
            // verify required parameter 'subscribeRequest' is not null or undefined
            assertParamExists('subscribe', 'subscribeRequest', subscribeRequest)
            const localVarPath = `/v2/prenotazioni/{id}/subscribe`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subscribeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Toglie un utente da una partita
         * @param {string} id 
         * @param {UnsubscribeRequest} unsubscribeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribe: async (id: string, unsubscribeRequest: UnsubscribeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('unsubscribe', 'id', id)
            // verify required parameter 'unsubscribeRequest' is not null or undefined
            assertParamExists('unsubscribe', 'unsubscribeRequest', unsubscribeRequest)
            const localVarPath = `/v2/prenotazioni/{id}/unsubscribe`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unsubscribeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PrenotazioniApi - functional programming interface
 * @export
 */
export const PrenotazioniApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PrenotazioniApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBookingDetail(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBookingDetail(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrenotazioniApi.getBookingDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Legge elenco prenotazioni
         * @param {boolean} [archived] 
         * @param {boolean} [deleted] 
         * @param {boolean} [future] 
         * @param {GetBookingsGroupTypeEnum} [groupType] 
         * @param {number} [limit] Any integer &gt; 0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBookings(archived?: boolean, deleted?: boolean, future?: boolean, groupType?: GetBookingsGroupTypeEnum, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BookingDetailsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBookings(archived, deleted, future, groupType, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrenotazioniApi.getBookings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Legge elenco prenotazioni per un determinato club in un dato giorno
         * @param {string} clubId 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalendar(clubId: string, date: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Booking>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCalendar(clubId, date, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrenotazioniApi.getCalendar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Legge elenco prossime N prenotazioni per lo user connesso  a partire da ora meno eventualmente X ore. N e X sono parametri di query opsionali che valgono 3 e 0 come default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNextBookings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BookingDetailsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNextBookings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrenotazioniApi.getNextBookings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get open games by club
         * @param {string} clubId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOpenGames(clubId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BookingDetailsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOpenGames(clubId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrenotazioniApi.getOpenGames']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSelf(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSelf(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrenotazioniApi.getSelf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Aggiunta campi nuovi su booking
         * @param {string} bookingId 
         * @param {BookingOtherFieldDTO} bookingOtherFieldDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setOtherField(bookingId: string, bookingOtherFieldDTO: BookingOtherFieldDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingOtherFieldDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setOtherField(bookingId, bookingOtherFieldDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrenotazioniApi.setOtherField']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Assegna un utente a una partita
         * @param {string} id 
         * @param {SubscribeRequest} subscribeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscribe(id: string, subscribeRequest: SubscribeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscribe(id, subscribeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrenotazioniApi.subscribe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Toglie un utente da una partita
         * @param {string} id 
         * @param {UnsubscribeRequest} unsubscribeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unsubscribe(id: string, unsubscribeRequest: UnsubscribeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unsubscribe(id, unsubscribeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrenotazioniApi.unsubscribe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PrenotazioniApi - factory interface
 * @export
 */
export const PrenotazioniApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PrenotazioniApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingDetail(id: string, options?: RawAxiosRequestConfig): AxiosPromise<BookingDetailsDto> {
            return localVarFp.getBookingDetail(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Legge elenco prenotazioni
         * @param {boolean} [archived] 
         * @param {boolean} [deleted] 
         * @param {boolean} [future] 
         * @param {GetBookingsGroupTypeEnum} [groupType] 
         * @param {number} [limit] Any integer &gt; 0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookings(archived?: boolean, deleted?: boolean, future?: boolean, groupType?: GetBookingsGroupTypeEnum, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<BookingDetailsDto>> {
            return localVarFp.getBookings(archived, deleted, future, groupType, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Legge elenco prenotazioni per un determinato club in un dato giorno
         * @param {string} clubId 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendar(clubId: string, date: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Booking>> {
            return localVarFp.getCalendar(clubId, date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Legge elenco prossime N prenotazioni per lo user connesso  a partire da ora meno eventualmente X ore. N e X sono parametri di query opsionali che valgono 3 e 0 come default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextBookings(options?: RawAxiosRequestConfig): AxiosPromise<Array<BookingDetailsDto>> {
            return localVarFp.getNextBookings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get open games by club
         * @param {string} clubId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpenGames(clubId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<BookingDetailsDto>> {
            return localVarFp.getOpenGames(clubId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSelf(options?: RawAxiosRequestConfig): AxiosPromise<User> {
            return localVarFp.getSelf(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Aggiunta campi nuovi su booking
         * @param {string} bookingId 
         * @param {BookingOtherFieldDTO} bookingOtherFieldDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOtherField(bookingId: string, bookingOtherFieldDTO: BookingOtherFieldDTO, options?: RawAxiosRequestConfig): AxiosPromise<BookingOtherFieldDTO> {
            return localVarFp.setOtherField(bookingId, bookingOtherFieldDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Assegna un utente a una partita
         * @param {string} id 
         * @param {SubscribeRequest} subscribeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribe(id: string, subscribeRequest: SubscribeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.subscribe(id, subscribeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Toglie un utente da una partita
         * @param {string} id 
         * @param {UnsubscribeRequest} unsubscribeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribe(id: string, unsubscribeRequest: UnsubscribeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unsubscribe(id, unsubscribeRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PrenotazioniApi - object-oriented interface
 * @export
 * @class PrenotazioniApi
 * @extends {BaseAPI}
 */
export class PrenotazioniApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrenotazioniApi
     */
    public getBookingDetail(id: string, options?: RawAxiosRequestConfig) {
        return PrenotazioniApiFp(this.configuration).getBookingDetail(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Legge elenco prenotazioni
     * @param {boolean} [archived] 
     * @param {boolean} [deleted] 
     * @param {boolean} [future] 
     * @param {GetBookingsGroupTypeEnum} [groupType] 
     * @param {number} [limit] Any integer &gt; 0
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrenotazioniApi
     */
    public getBookings(archived?: boolean, deleted?: boolean, future?: boolean, groupType?: GetBookingsGroupTypeEnum, limit?: number, options?: RawAxiosRequestConfig) {
        return PrenotazioniApiFp(this.configuration).getBookings(archived, deleted, future, groupType, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Legge elenco prenotazioni per un determinato club in un dato giorno
     * @param {string} clubId 
     * @param {string} date 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrenotazioniApi
     */
    public getCalendar(clubId: string, date: string, options?: RawAxiosRequestConfig) {
        return PrenotazioniApiFp(this.configuration).getCalendar(clubId, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Legge elenco prossime N prenotazioni per lo user connesso  a partire da ora meno eventualmente X ore. N e X sono parametri di query opsionali che valgono 3 e 0 come default
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrenotazioniApi
     */
    public getNextBookings(options?: RawAxiosRequestConfig) {
        return PrenotazioniApiFp(this.configuration).getNextBookings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get open games by club
     * @param {string} clubId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrenotazioniApi
     */
    public getOpenGames(clubId: string, options?: RawAxiosRequestConfig) {
        return PrenotazioniApiFp(this.configuration).getOpenGames(clubId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrenotazioniApi
     */
    public getSelf(options?: RawAxiosRequestConfig) {
        return PrenotazioniApiFp(this.configuration).getSelf(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Aggiunta campi nuovi su booking
     * @param {string} bookingId 
     * @param {BookingOtherFieldDTO} bookingOtherFieldDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrenotazioniApi
     */
    public setOtherField(bookingId: string, bookingOtherFieldDTO: BookingOtherFieldDTO, options?: RawAxiosRequestConfig) {
        return PrenotazioniApiFp(this.configuration).setOtherField(bookingId, bookingOtherFieldDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Assegna un utente a una partita
     * @param {string} id 
     * @param {SubscribeRequest} subscribeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrenotazioniApi
     */
    public subscribe(id: string, subscribeRequest: SubscribeRequest, options?: RawAxiosRequestConfig) {
        return PrenotazioniApiFp(this.configuration).subscribe(id, subscribeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Toglie un utente da una partita
     * @param {string} id 
     * @param {UnsubscribeRequest} unsubscribeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrenotazioniApi
     */
    public unsubscribe(id: string, unsubscribeRequest: UnsubscribeRequest, options?: RawAxiosRequestConfig) {
        return PrenotazioniApiFp(this.configuration).unsubscribe(id, unsubscribeRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetBookingsGroupTypeEnum = {
    Tournament: 'TOURNAMENT',
    Booking: 'BOOKING',
    Reservations: 'RESERVATIONS',
    Open: 'OPEN',
    App: 'APP',
    Backoffice: 'BACKOFFICE',
    Lessons: 'LESSONS'
} as const;
export type GetBookingsGroupTypeEnum = typeof GetBookingsGroupTypeEnum[keyof typeof GetBookingsGroupTypeEnum];


